import React, { Component } from 'react';
import { createCombineReducers } from 'mt-react-common/modules/complaints/addComplaintForm/combineRegistry';
import PropTypes from 'prop-types';
import ComplaintReportPopUpForComment from './ComplaintReportPopUpForComment';

class StatusesDescTableRWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `addComplaintForm-Comment-${this.props.id}`
    };
  }

  componentWillMount() {
    createCombineReducers(this.state.reducerName);
  }

  render() {
    return (
      <React.Fragment>
        <ComplaintReportPopUpForComment
          {...this.props}
          reducerName={this.state.reducerName}
        />
      </React.Fragment>
    );
  }
}

StatusesDescTableRWrapper.propTypes = {
  id: PropTypes.string.isRequired
};

export default StatusesDescTableRWrapper;



// WEBPACK FOOTER //
// ./src/components/Complaints/ComplaintReportPopUpForComment/index.js